import { render, staticRenderFns } from "./VideoAndPromotionComponent.vue?vue&type=template&id=aeed43b8&"
import script from "./VideoAndPromotionComponent.vue?vue&type=script&lang=js&"
export * from "./VideoAndPromotionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports